(function(){ 

    var _categoryItemTemplate = '<li><a href="#{{categoryID}}" data-cate-biztype="{{bizType}}" data-cate-id="{{categoryID}}">{{categoryName}}</a></li>';
     
    // [.prd-care-vertical 옵션]
    // 1. 타입
    // .module-type1 : 케어솔루션_제품모튤
    // .module-type2 : 케어십_유상제품 모듈
    // .module-type3 : 케어십_보유제품 모듈
    // .module-type4 : 케어십_용역제품 모듈
    // .module-type6 : 구독서비스용 구분 클래스_구독서비스 신규 추가
    // 20210720 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
	// 20220125 BTOCSITE-9177 RAC 관련 서비스 타입 추가 요청
	// 20220316 BTOCSITE-13244 케어플래너 PLP 스펙 노출 및 문구 수정 건 
    var _listItemTemplate =
    //221024 구독 서비스용 PLP 디자인 수정에 따른 템플릿 마크업 변경 - S
    //정기 구독 서비스용(module-type6) CASE - S 
        '{{#if moduleType =="module-type6"}}' +
        '<li class="item">'+
        '   <div class="prd-care-vertical {{moduleType}}{{#if prdStatus=="SOLDOUT"}} soldout{{/if}}" data-index="{{index}}">'+ 
        '       <div class="top-area">' +
        '           <a href="{{modelUrlPath}}" class="link_product_detail">'+ 
        '               <div class="img-wrap">'+
        '                   <img src="{{modelImg}}" alt="{{#raw userFriendlyName}}">'+
        '               </div>'+
        '               <div class="txt-wrap">'+
        // BTOCSITE-22701 :: 구독서비스 2차 추가 - badge-wrap 영역 - S
        '                   {{#if (badgeList != null && badgeList != "" && badgeList != undefined) }}' +
        '                   <ul class="badge-wrap">' +
        '                   {{#each item in badgeList}}'+
        '                       {{#if item.badgeGubun == "bold_text"}}' +
        '                       <li class="badge{{#if item.boldFlag =="Y"}} bold-pink{{/if}}">{{item.badgeName}}</li>' +
        '                       {{/if}}' +
        '                   {{/each}}' +
        '                   </ul>' +
        '                   {{/if}}' +
        '                   {{#if (multiOrderFlag != "N" && multiOrderFlag != undefined) && rentalCareType == "R" }}' +
        '                       <div class="flag-wrap bar-type">'+
        '                           <span class="flag"><span class="blind">제품타입</span>다품목할인</span>'+
        '                       </div>'+
        '                   {{/if}}' +
        // BTOCSITE-22701 :: 구독서비스 2차 추가 - badge-wrap 영역 - E
        '                   <p class="tit"><span class="blind">제품 디스플레이 네임</span>{{#raw userFriendlyName}}</p>'+
        '                   <p class="code"><span class="blind">제품 코드</span>{{modelName}}</p>'+
        '		            {{#if reviewsCount > 0}}'+
        '	    	        <div class="review-info">'+
        '   		            <div class="star is-review"><span class="blind">리뷰있음</span></div>'+
        '    		            <div class="average-rating"><span class="blind">평점</span>{{reviewsScore}}</div>'+
        '    		            <div class="review-count"><span class="blind">리뷰 수</span> ({{reviewsCount}})</div>'+
        '		            </div>'+
        '		            {{/if}}'+
        // BTOCSITE-22701 :: 구독서비스 2차 추가 - benefit-wrap 혜택 부분 - S
        '               {{#if (badgeList != null && badgeList != "" && badgeList != undefined) }}' +
        '               <ul class="benefit-wrap">' +
        '               {{#each item in badgeList}}'+
        '                   {{#if item.badgeGubun == "sale_benefit"}}' +
        '                   <li>{{item.badgeName}}</li>' +
        '                   {{/if}}' +
        '               {{/each}}' +
        '               </ul>' +
        '               {{/if}}' +
        '           </a>'+
        // BTOCSITE-22701 :: 구독서비스 2차 추가 - benefit-wrap 혜택 부분 - E
        '       </div>'+
        // 구독서비스 수정(221007)_서비스정보 및 금액 영역 - S
        '       <div class="info-wrap">'+
        // BTOCSITE-22701 :: 구독서비스 2차 키값 변경 - S
        '           {{#if (svcOptType != null && svcOptType != "" && svcOptType != undefined) || (svcCycle != null && svcCycle != "" && svcCycle != undefined)}}'+
        '               <div class="service-info">'+
        '                   <ul>'+
        '                   {{#if svcOptType != null && svcOptType != undefined && svcOptType != ""}}'+
        '                       <li>'+
        '                           <p class="option1">서비스 유형 : <span class="ans">{{svcOptType}}</span></p>' +
        '                       </li>'+
        '                   {{/if}}'+
        '                   {{#if svcCycle != null && svcCycle != undefined && svcCycle != ""}}'+
        '                       <li>'+
        '                           <p class="option1">서비스 주기 : <span class="ans">{{svcCycle}}</span></p>' +
        '                       </li>'+
        '                   {{/if}}'+
        '                   </ul>'+
        '               </div>'+
        '           {{/if}}' +
        // BTOCSITE-22701 :: 구독서비스 2차 키값 변경 - E
        '       </div>' +
        '       </div>' +
        '       {{#if totalPrice !== ""}}' +
        '		<div class="bottom-area">' +
        '		  <div class="txt-info-wrap">' +
        '			<div class="txt-info">' +
        '				{{#if percent !== "" && percent !== "0%"}}' +
        '				<dl>' +
        '					<dt>상품 판매가</dt>' +
        '					<dd><span class="df-price">월 {{totalPrice}}</span></dd>' +
        '				</dl>' +
        '				<dl>' +
        '					<dt>상품 혜택가</dt>' +
        '					<dd>{{#if percent !== "" && percent !== "0%"}}<span class="percent">{{percent}}</span>{{/if}}월 {{currentPrice}}</dd>' +
        '				</dl>' +
        '				{{#else}}' +
        '				<dl>' +
        '					<dt>상품 판매가</dt>' +
        '					<dd><span>월 {{totalPrice}}</span></dd>' +
        '				</dl>' +
        '				{{/if}}' +
        '			</div>' +
        '		  </div>' +
        '         {{#if prdStatus === "ACTIVE" }}'+
        '         <div class="price-info">' +
        '           <p class="text">이용 요금<span class="sub-text">(1회차 월 요금 기준)</span></p>' +
        '             <div class="request-area">' +
        '                {{#if percent !== "0%"}}'+
        '                   {{#if scModelPrice === "range"}}' +
        '   				<div class="total-price">' + 
        '	    				<p>월 <span class="num">{{currentPrice}}</span> ~ </p>' +
        '		   			</div>' +
        '                {{#else}}' +
        '                   {{#if scModelPrice === "min"}}' +
        '	    	    	<div class="total-price">' + 
        '		 		    	<p>월 <span class="num">{{currentPrice}}</span></p>' +
        '			        </div>' +
        '                   {{#else}}' +
        '				   	<div class="total-price">' + 
        '				       	<p>월 <span class="num">{{totalPrice}}</span></p>' +
        '				    </div>' +
        '                   {{/if}}' +
        '                {{/if}}' +
        '                {{#else}}' +
        '                   {{#if scModelPrice === "range"}}' +
        '   				<div class="total-price">' + 
        '	    				<p>월 <span class="num">{{currentPrice}}</span> ~ </p>' +
        '		    		</div>' +
        '                   {{#else}}' +
        '                   {{#if scModelPrice === "min"}}' +
        '	    			<div class="total-price">' + 
        '		    		   	<p>월 <span class="num">{{currentPrice}}</span></p>' +
        '			    	</div>' +
        '                       {{#else}}' +
        '				    	<div class="total-price">' + 
        '					       	<p>월 <span class="num">{{totalPrice}}</span></p>' +
        '					    </div>' +
        '                       {{/if}}' +
        '                   {{/if}}' +
        '				 {{/if}}' +
        '           	 {{#if btnText !== "" }}' +
        '                <a href="{{#if prdStatus !== "SOLDOUT"}}{{modelUrlPath}}{{#else}}javascript:;{{/if}}" class="btn btn-subscribe{{#if prdStatus != null && prdStatus != undefined && prdStatus !== "ACTIVE"}} inactive{{/if}}" {{#if prdStatus ==="ACTIVE"}}id="subscribeBtn{{index}}"{{/if}}><span>{{#if prdStatus ==="ACTIVE"}}자세히 보기{{/if}}{{#if prdStatus ==="SOLDOUT"}}품절{{/if}}</span></a>' +
        '           	 {{/if}}' +
        '             </div>' +
        '         </div>' +
        '         {{/if}}' +
        '         {{#if prdStatus === "SOLDOUT" }}'+
        '            <div class="price-info">' +
        '               <p class="text">이용 요금<span class="sub-text">(1회차 월 요금 기준)</span></p>' +
        '               <div class="request-area">' +
        '                   {{#if percent !== "0%"}}'+
        '                       {{#if scModelPrice === "range"}}' +
        '   					<div class="total-price">' + 
        '	    					<p>월 <span class="num">{{currentPrice}}</span> ~ </p>' +
        '		    			</div>' +
        '                       {{#else}}' +
        '                          {{#if scModelPrice === "min"}}' +
        '	    			    	<div class="total-price">' + 
        '		    			    	<p>월 <span class="num">{{currentPrice}}</span></p>' +
        '			    		    </div>' +
        '                           {{#else}}' +
        '				        	<div class="total-price">' + 
        '					        	<p>월 <span class="num">{{totalPrice}}</span></p>' +
        '					        </div>' +
        '                           {{/if}}' +
        '                       {{/if}}' +
        '                   {{#else}}' +
        '                       {{#if scModelPrice === "range"}}' +
        '   					<div class="total-price">' + 
        '	    					<p>월 <span class="num">{{currentPrice}}</span> ~ </p>' +
        '		    			</div>' +
        '                       {{#else}}' +
        '                          {{#if scModelPrice === "min"}}' +
        '	    			    	<div class="total-price">' + 
        '		    			    	<p>월 <span class="num">{{currentPrice}}</span></p>' +
        '			    		    </div>' +
        '                           {{#else}}' +
        '				        	<div class="total-price">' + 
        '					        	<p>월 <span class="num">{{totalPrice}}</span></p>' +
        '					        </div>' +
        '                           {{/if}}' +
        '                       {{/if}}' +
        '					{{/if}}' +
        '           		{{#if btnText !== "" }}' +
        '               	<a href="{{#if prdStatus !== "SOLDOUT"}}{{modelUrlPath}}{{#else}}javascript:;{{/if}}" class="btn btn-subscribe{{#if prdStatus != null && prdStatus != undefined && prdStatus !== "ACTIVE"}} inactive{{/if}}" {{#if prdStatus ==="ACTIVE"}}id="subscribeBtn{{index}}"{{/if}}><span>{{#if prdStatus ==="ACTIVE"}}자세히 보기{{/if}}{{#if prdStatus ==="SOLDOUT"}}품절{{/if}}</span></a>' +
        '           		{{/if}}' +
        '               </div>' +
        '             </div>' +
        '             {{/if}}' +
        '			</div>'+
        '           {{/if}}' +
        // 구독서비스 수정_서비스정보 및 금액 영역 - E
        //221024 구독 서비스용 PLP 디자인 수정에 따른 템플릿 마크업 변경 - E
        '   </div>'+
        '</li>'+
        //정기 구독 서비스용(module-type6) CASE - E
        //이 외 기존 AS-IS CASE - S
        '{{#else}}' +
        '<li class="item">'+
        '   <div class="prd-care-vertical {{moduleType}}" data-index="{{index}}">'+
        '		{{#if moduleType == "module-type1" || moduleType == "module-type2"|| moduleType == "module-type5"}}<a href="{{modelUrlPath}}" class="link_product_detail">{{/if}}'+
        '           <div class="img-wrap">'+
        '               <img src="{{modelImg}}" alt="{{#raw userFriendlyName}}">'+
        '           </div>'+
        '           <div class="txt-wrap">'+
        '           {{#if moduleType == "module-type3"}}'+
        '           <div class="flag-wrap"><span class="flag">보유제품</span></div>'+
        '           {{/if}}'+
        '           {{#if multiOrderFlag != undefined && multiOrderFlag != "N" && rentalCareType == "R" }}' +
        '               <div class="flag-wrap bar-type">'+
        '                   <span class="flag"><span class="blind">제품타입</span>다품목할인</span>'+
        '               </div>'+
        '           {{/if}}' +
        '           <p class="tit"><span class="blind">제품 디스플레이 네임</span>{{#raw userFriendlyName}}</p>'+
        '           <p class="code"><span class="blind">제품 코드</span>{{modelName}}</p>'+
		'		    {{#if reviewsCount > 0}}'+
        '		    <div class="review-info">'+
        '   		    <div class="star is-review"><span class="blind">리뷰있음</span></div>'+
        '    		    <div class="average-rating"><span class="blind">평점</span>{{reviewsScore}}</div>'+
        '    		    <div class="review-count"><span class="blind">리뷰 수</span>({{reviewsCount}})</div>'+
        '		    </div>'+
        '		    {{/if}}'+
        '           </div>'+
		'		    {{#if specList.length > 0}}'+
        '		    <ul class="spec-info">'+
        '           {{#each item in specList}}'+
        '			    <li>{{item.specText}}</li>'+      
        '           {{/each}}'+
        '		    </ul>'+
        '		    {{/if}}'+
        '		{{#if moduleType == "module-type1" || moduleType == "module-type2"|| moduleType == "module-type5"}}</a>{{/if}}'+
        '       <div class="info-wrap">'+
        '       {{#if moduleType == "module-type4"}}'+
        '           <p class="code-txt">{{modelDescription}}</p>'+
        '       {{/if}}'+
        '       {{#if purchaseInfo != null && purchaseInfo != undefined && purchaseInfo != ""}}'+
        '           <div class="txt-info">'+
        '           {{#each item in purchaseInfo}}'+
        '               <dl>'+
        '                   <dt>{{item.title}}</dt>'+
        '                   <dd>{{item.date}}</dd>'+
        '               </dl>'+
        '           {{/each}}'+
        '           </div>'+
        '       {{/if}}'+
        '           <div class="opt-info">'+
        '           {{#if siblingColors.length > 0}}'+
        '               <dl {{#if siblingColors.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>{{siblingTypeName}}</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" id="colorSet-{{modelId}}" title="{{siblingTypeName}} 선택" data-sibling-type="siblingColors" {{#if siblingColors.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingColors}}'+
        '                               <option data-model-id="{{item.modelId}}"'+
                                                    ' data-group-id="{{item.siblingGroupCode}}"'+
                                                    ' value="{{item.siblingCode}}"'+
                                                    '{{#if selectColorID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if typeof siblingContractPeriod !== "undefined" && siblingContractPeriod.length > 0}}'+
        '               <dl {{#if siblingContractPeriod.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>계약기간</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" data-combo-id="1" id="contractPeriodSet-{{modelId}}" title="계약기간 선택" data-sibling-type="siblingContractPeriod" {{#if siblingContractPeriod.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingContractPeriod}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectContractPeriodID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if siblingUsePeriod.length > 0}}'+
        '               <dl {{#if siblingUsePeriod.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>의무사용</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" data-combo-id="2" id="usePeriodSet-{{modelId}}" title="의무사용 선택" data-sibling-type="siblingUsePeriod" {{#if siblingUsePeriod.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingUsePeriod}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectUserPeriodID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if siblingVisitCycle.length > 0}}'+
        '               <dl {{#if siblingVisitCycle.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>방문주기</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" data-combo-id="3" id="visiSet-{{modelId}}" title="방문주기 선택" data-sibling-type="siblingVisitCycle" {{#if siblingVisitCycle.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingVisitCycle}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectVisitCycleID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if siblingFee.length > 0}}'+
        '               <dl {{#if siblingFee.length == 1}}class="disabled"{{#each item in siblingFee}}{{#if item.siblingCode == 0}} style="display:none"{{/if}}{{/each}}{{/if}}>'+
        '                   <dt>가입비</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" data-combo-id="4" id="feeSet-{{modelId}}" title="가입비 선택" data-sibling-type="siblingFee" {{#if siblingFee.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingFee}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectFeeID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+      
		'           {{#if typeof siblingSvcType !== "undefined" && siblingSvcType.length > 0}}'+        
        '               <dl {{#if siblingSvcType.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>서비스타입</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" data-combo-id="5" id="svcTypeSet-{{modelId}}" title="서비스타입선택" data-sibling-type="siblingSvcType" {{#if siblingSvcType.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingSvcType}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectSvcTypeCd==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+  
        '           </div>'+
        '       {{#if priceInfo != null && priceInfo != undefined && priceInfo != ""}}'+
        '           <div class="txt-info price-info">'+
        '           {{#each item in priceInfo}}'+
        '               <dl>'+
        '                   <dt>{{item.title}}</dt>'+
        '                   <dd>{{item.price}}원</dd>'+
        '               </dl>'+
        '           {{/each}}'+
        '           </div>'+
        '       {{/if}}'+
        '           <div class="price-wrap">'+
		'				<em class="text">이용 요금 <span class="small-text">(1년차 월 요금 기준)</span></em>'+
        '               <div class="total-price">'+
        '                   <p class="price">월 <span>{{monthlyPrice}}</span>원</p>'+ //BTOCSITE-73428 가전연계구독할인 - 금액 태그 변경
        '                   <button type="button" class="btn border putItemBtn"><span>담기</span></button>'+
        '               </div>'+
        '           </div>'+
        '       </div>'+
        '   </div>'+
        '</li>'+
        '{{/if}}';
        //이 외 기존 AS-IS CASE - E
        //221024 구독 서비스용 PLP 디자인 수정에 따른 템플릿 마크업 변경 - E

        //<!-- 결합된 상품이면 comb-type 클래스 추가 -->
    var _putItemTemplate = 
        '<div class="slide-wrap ui_carousel_slider3">'+
        '   <div class="slide-content ui_carousel_list">'+
        '       <ul class="slide-track ui_carousel_track">'+ //BTOCSITE-73428 div->ul 마크업 준수로 태그 변경
        '       {{#each item in putitem_list}}'+
        '           <li class="slide-conts ui_carousel_slide">'+
        '               <div class="conts-wrap">'+
        '                   <div class="prd-care-horizon ui_flexible_box comb-type">'+
        '                       <div class="ui_flexible_cont">'+
        '                           <div class="badge">' +
        '                               {{#if item.badgeList != null && item.badgeList.length > 0}}'+
        '                               <ul>'+
        '                                   {{#each badge in item.badgeList}}' +
        '                                   <li>{{badge}}</li>'+
        '                                   {{/each}}'+
        '                               </ul>'+
        '                               {{/if}}'+
        '                           </div>'+
        '                           <div class="img-wrap">'+
        '                               <img src="{{item.modelImg}}" alt="{{#raw item.displayName}}">'+
        '                           </div>'+
        '                           <div class="txt-wrap">'+
        '                             <div class="flag-wrap bar-type">'+
        '                                   <span class="flag"><span class="blind">서비스명</span>{{item.contractTypeNm}}</span>'+
        '                               {{#if item.multiOrderFlag != null && item.multiOrderFlag != undefined && item.multiOrderFlag != "N" }}' +
        '                                    <span class="flag"><span class="blind">제품타입</span>다품목할인</span>'+
        '                               {{/if}}'+
        '                               </div>'+
        '                               <div class="tit-info">'+
        '                                   <p class="tit"><span class="blind">제품 디스플레이 네임</span>{{#raw item.displayName}}</p>'+
        '                                   <p class="code"><span class="blind">제품 코드</span>{{item.modelName}}</p>'+
        '                               </div>'+
        '                               <div class="etc">' +
        '                                   <dl class="amount">' +
        '                                       <dt>월 <span>{{item.originalPrice}}</span>원</dt>' +
        '                                   {{#if item.dcList != null && item.dcList.length > 0}}' +
        '                                       {{#each dcInfo in item.dcList}}'+
        '                                          <dd>' +
        '                                               <p>{{dcInfo.dcTitle}}</p>' +
        '                                               <p class="comb-txt">월 <span>-{{dcInfo.dcAmtTxt}}</span>원</p>' +
        '                                          </dd>' +
        '                                       {{/each}}'+
        '                                   {{/if}}'+
        '                               </div>'+
        '                           </div>'+  
        '                           <div class="del-item">'+
        '                               <button type="button" class="btn-del" tabindex="" data-model-id="{{item.modelId}}"><span class="blind">제품 삭제</span></button>'+
        '                           </div>'+  
        '                       </div>'+
        '                   </div>'+
        '               </div>'+
        '           </li>'+
        '       {{/each}}'+
        '       </ul>'+ //BTOCSITE-73428 div->ul 마크업 준수로 태그 변경
        '   </div>'+
        '   <div class="slide-controls">'+
        '       <button type="button" class="btn-arrow prev ui_carousel_prev"><span class="blind">이전</span></button>'+
        '       <button type="button" class="btn-arrow next ui_carousel_next"><span class="blind">다음</span></button>'+
        '   </div>'+
        '</div>';
    
    //무상케어십 계약
    var freeCareshipTemplate =
        '<li class="slide-conts ui_carousel_slide freeCareshipBox">'+
            '<div class="conts-wrap">'+
                '<div class="prd-care-horizon ui_flexible_box free-care comb-type">'+
                    '<div class="ui_flexible_cont">'+
                        '<p>케어십 일시납 확인으로 <br>기존 결합 할인 적용되었습니다.</p>'+
                        '<span>기존계약 문의 1544-7777</span>'+
                    '</div>'+
                '</div>'+
            '</div>'+
        '</li>';

    var addFreeCareShipTempalte = 
        '<li class="slide-conts ui_carousel_slide freeCareshipBox">'+
            '<div class="conts-wrap">'+
                '<div class="prd-care-horizon ui_flexible_box holding-care2">'+
                    '<div class="ui_flexible_cont">'+
                        '<div class="box">'+
                            '<p class="tit">케어십 일시납 확인으로 기존 제품과의<br>결합 할인이 가능합니다.<br>제품을 담아 할인을 받아보세요.</p>'+
                            '<p class="txt">결합 할인 가능 제품만 해당, 기존계약 문의 1544-7777</p>'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</div>'+
        '</li>';

    var putItemPriceTemplate = 
        '<div class="total-info">'+
            '<dl class="amount">'+
                '<dt>이용 요금 (1년차 월 요금 기준)</dt>'+
                '<dd>월 <span>{{totalPrice}}</span>원</dd>'+
            '</dl>'+
        '   {{#if totalDcList != null && totalDcList.length > 0}}' +
        '       {{#each dcInfo in totalDcList}}'+
        '          {{#if dcInfo.type == "price"}}'+
                    '<dl>'+
                        '<dt>{{dcInfo.dcTitle}}</dt>'+
                        '<dd class="sale">월 <span>-{{dcInfo.dcAmtTxt}}</span>원</dd>'+
                    '</dl>'+
        '           {{/if}}' +
        '       {{/each}}' +
            '{{/if}}'+
        '   {{#if affiliateCard != null && affiliateCard != ""}}' +
            '<dl class="last">'+
                '<dt><a href="#alliancePopup" data-control="modal">제휴카드 할인</a></dt>'+
                '<dd class="sale sm">월 최대 <span>-{{affiliateCard}}</span>원</dd>'+
            '</dl>'+
        '   {{/if}}' +
            '<a href="#n" class="btn"><span>견적 확인하기</span></a>'+
        '</div>';

        var _estimateProdTemplate =
            '<div class="estimate-list">'+
            '<ul>'+
            '   {{#each item in itemList}}'+
            '   <li class="item">'+
            '       <div class="img-wrap">'+
            '           <img src="{{item.imageUrl}}" alt="{{#raw item.displayName}}">'+
            '       </div>'+
            '       <div class="txt-wrap">'+
            '           <div class="txt-content-left">' +
            '               <div class="flag-wrap bar-type">'+
            '                   <span class="flag"><span class="blind">서비스명</span>{{item.contractTypeNm}}</span>'+
            '                   {{#if item.multiOrderFlag != null && item.multiOrderFlag != undefined && item.multiOrderFlag != "N" }}' +
            '                      <span class="flag"><span class="blind">제품타입</span>다품목할인</span>'+
            '                   {{/if}}'+
            '               </div>'+
            '               <div class="tit-info">'+
            '                   <p class="tit"><span class="blind">제품 디스플레이 네임</span>{{#raw item.displayName}}</p>'+
            '                   <div class="etc-info">'+
            '                       <span class="txt"><span class="blind">제품 코드</span>{{item.modelName}}</span>'+
            '                       {{#if item.colorOption}}<span class="txt"><span class="blind">색상</span>{{item.colorOption}}</span>{{/if}}'+
            '                   </div>'+
            '               </div>'+
            '               <div class="etc-info">'+
            '                   {{#each info in item.option}}'+
            '                   <span class="txt">{{#raw info}}</span>'+
            '                   {{/each}}'+
            '               </div>'+
            '           {{#if item.careShipNotice}}' +
            '           {{#raw item.careShipNotice}}' +
            '           {{/if}}' +
            '           {{#if item.reOrderDcYn == "Y"}}' +
            '               <div class="discount-info">' +
            '                  <p class="discount-txt">{{reOrderNoticeTooltip.title}}</p>' +
            '                  <div class="tooltip-wrap">' +
            '                       <span class="tooltip-icon ui_tooltip-target" ui-modules="TooltipTarget">자세히 보기</span>' +
            '                       <div class="tooltip-box tooltip-sale-info">' +
            '                           <p>{{reOrderNoticeTooltip.text}}</p>' +
            '                           <button type="button" class="btn-close"><span class="blind">닫기</span></button>' +
        '                           </div>' +
            '                   </div>' +
            '               </div>' +
            '           {{/if}}' +
            '           </div>'+
            '           <div class="price-info">'+
            '               {{#if item.originalPrice}}<p class="price sale"><span class="blind">기본 이용 요금</span>월 <span>{{item.originalPrice}}</span>원</p>{{/if}}'+
            '               <p class="price"><span class="blind">최종 이용 요금</span>월 <span>{{item.monthPrice}}</span>원</p>'+
            '           </div>'+
            '       </div>'+
            '   </li>'+
            '   {{/each}}'+// BTOCSITE-73428 가전연계구독할인 - each문 닫는 위치 변경
            '</ul>'+
            '</div>';
            
    var noData = '<div class="no-data"><p>해당 카테고리의 제품이 없습니다.</p></div>';
    var subNoData = '<div class="no-data"><p>해당 카테고리의 상품이 없습니다.</p></div>';

    var _showItemLength = 8;

    var _isStorageChk = false;
    var _isStickyApply = false;
    var _isLanding = !!location.hash ? true : false; // BTOCSITE-22701 :: 구독이벤트 링크 관련 랜딩여부
    // BTOCSITE-22701 :: 구독이벤트 링크 관련 해쉬맵
    // BTOCSITE-24685 START
    var _landingCategoryMap = {
    		'#rental_water-purifiers' : {
                tab : 0,
                categoryName : '정수기'
            },
    		'#rental_water-purifiers-refrigerator' : {
                tab : 0,
                categoryName : '얼음정수기냉장고'
            },
            '#rental_refrigerators' : {
                tab : 0,
                categoryName : '냉장고'
            },
    		'#rental_air-purifiers' : {
                tab : 0,
                categoryName : '공기청정기'
            },
    		'#rental_aerotower' : {
                tab : 0,
                categoryName : '에어로타워'
            },
    		'#rental_aero-furniture' : {
                tab : 0,
                categoryName : '에어로퍼니처'
            },
    		'#rental_air-conditioners' : {
                tab : 0,
                categoryName : '에어컨'
            },
    		'#rental_electric-stoves' : {
                tab : 0,
                categoryName : '전기레인지'
            },
    		'#rental_dishwashers' : {
                tab : 0,
                categoryName : '식기세척기'
            },
            '#rental_wash-tower' : {
                tab : 0,
                categoryName : '워시타워'
            },
    		'#rental_washing-machines' : {
                tab : 0,
                categoryName : '세탁기'
            },
    		'#rental_dryers' : {
                tab : 0,
                categoryName : '의류건조기'
            },
            '#rental_lg-styler' : {
                tab : 0,
                categoryName : '스타일러'
            },
    		'#rental_massage-chairs' : {
                tab : 0,
                categoryName : '안마의자'
            },
    		'#rental_lg-tiiun' : {
                tab : 0,
                categoryName : '식물생활가전'
            },
            '#rental_washtower' : {
                tab : 0,
                categoryName : '워시타워'
            },
            '#rental_kimchi-refrigerators' : {
            	tab : 0,
            	categoryName : '김치냉장고'
            },
    		'#careship_water-purifiers' : {
                tab : 1,
                categoryName : '정수기'
            },
    		'#careship_ice-water-purifiers-refrigerator' : {
                tab : 1,
                categoryName : '얼음정수기냉장고'
            },
    		'#careship_air-purifiers' : {
                tab : 1,
                categoryName : '공기청정기'
            },
    		'#careship_electronic-mask' : {
                tab : 1,
                categoryName : '전자식 마스크'
            },
    		'#careship_aerotower' : {
                tab : 1,
                categoryName : '에어로타워'
            },
    		'#careship_aero-furniture' : {
                tab : 1,
                categoryName : '에어로퍼니처'
            },
    		'#careship_air-conditioners' : {
                tab : 1,
                categoryName : '에어컨'
            },
    		'#careship_electric-stoves' : {
                tab : 1,
                categoryName : '전기레인지'
            },
    		'#careship_dishwashers' : {
                tab : 1,
                categoryName : '식기세척기'
            },
    		'#careship_lg-homebrew' : {
                tab : 1,
                categoryName : '맥주제조기'
            },
    		'#careship_wash-tower' : {
                tab : 1,
                categoryName : '워시타워'
            },
            '#careship_washing-machines' : {
            	tab : 1,
            	categoryName : '세탁기'
            },
    		'#careship_dryers' : {
                tab : 1,
                categoryName : '의류건조기'
            },
            '#careship_vacuum-cleaners-r' : {
                tab : 1,
                categoryName : '청소기'
            },
    		'#careship_vacuum-cleaners-s' : {
                tab : 1,
                categoryName : '청소기-자가관리'
            },
    		'#careship_lg-tiiun' : {
                tab : 1,
                categoryName : '식물생활가전'
            },
            '#careship_washtower' : {
                tab : 1,
                categoryName : '워시타워'
            },
            '#careship_kimchi-refrigerators' : {
            	tab : 1,
            	categoryName : '김치냉장고'
            }
        };
    	// BTOCSITE-24685 END

    var _page, _pageTotal;
    var _currentItemList;

    var _prodListUrl;
    var _categoryListUrl;

    var _changeColorUrl;
    var _priceStatusUrl;
    var _putItemUrl;
    var _estimateConfirmUrl;

    var _putItemList = [];

    var $caresolutionContainer;
    var $fixedTab;
    var $serviceTab;
    var $categoryTab;
    var $categoryTabCtrler;
    var $sortSelector;
    var $prodListContainer;
    var $putItemContainer;

    var _serviceID = 0;

    var _careCateId = "";
    var _isDirectCare = false;
    var loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";

    function init(){
        vcui.require(['ui/carousel', 'ui/tab', 'ui/sticky', 'ui/modal', 'ui/selectbox', 'ui/smoothScrollTab'], function () {
            setting();
            eventBind();

            // BTOCSITE-5938-204 하단 푸터 가리는 현상 수정
            if($('.default-bottom-wrap').is(':visible')) {
                $('footer').addClass('default-bottom-wrap');
            }
        });
    }

    function setting(){       

        $caresolutionContainer = $('.care-solution-wrap');
        $fixedTab = $('.fixed-tab-wrap');
        $serviceTab = $fixedTab.find('.tabs-wrap.new-type');
        $categoryTab = $fixedTab.find('.cate-scroll-wrap');
        $sortSelector = $('.sort-select-wrap select');
        $prodListContainer = $('.prd-list-wrap');
        $putItemContainer = $('.prd-select-wrap');

        _putMaxCount = $caresolutionContainer.data("maxCount");
        _categoryListUrl = $caresolutionContainer.data("cateList");
        _prodListUrl = $caresolutionContainer.data("prodList");

        _changeColorUrl = $caresolutionContainer.data("colorModel");
        _priceStatusUrl = $caresolutionContainer.data("priceStatus");
        _putItemUrl = $caresolutionContainer.data("putItem");
        _estimateConfirmUrl = $caresolutionContainer.data("estimateConfirm");

        _careCateId = $caresolutionContainer.data("careCateId");


        
        if(loginFlag == "Y"){//로그인시
        	$("#beforeLoginContract").hide();
        	$("#afterLoginContract").show();
        }else{//비로그인시
        	$("#beforeLoginContract").show();
        	$("#afterLoginContract").hide();
        }

        $fixedTab.find('.service_tab').vcTab()
        .on('tabchange', function(e, data){
            /* BTOCSITE-40053 s */
            var categorytop = $caresolutionContainer.offset().top;
            $('html').animate({scrollTop:categorytop}, 120);
            /* BTOCSITE-40053 e */
            changeService(data.selectedIndex)
        });

        $categoryTabCtrler = new vcui.ui.SmoothScrollTab('.ui_smoothScroll_tab');
        
        /* BTOCSITE-29875 [QA869] 렌탈/케어십 요금 확인 제품 카드 오류 start */
        /*
        $(window).on('breakpointchange', function(e){
            var breakpoint = window.breakpoint;    
            if(breakpoint.name == 'pc'){    
                $('.contents.care-plan').find('.ui_carousel_slider').vcCarousel({
                    responsive: [
                        {
                            breakpoint: 10000,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 3,
                                slidesToScroll: 3
                                
                            }
                        },
                        {
                            breakpoint: 1090,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 2, 
                                slidesToScroll: 2
                            }
                        }
                    ]
                });   
                $('.contents.care-plan').find('.ui_carousel_slider .slide-controls').show();
            }else if(breakpoint.name == 'mobile'){    
                $('.contents.care-plan').find('.ui_carousel_slider').vcCarousel('destroy');    
                $('.contents.care-plan').find('.ui_carousel_slider .slide-controls').hide();                        
            }    
        });
        */
        
        $(window).on('breakpointchange', function(e){
            var breakpoint = window.breakpoint;
            if(breakpoint.name == 'pc'){    
                $(".contents.care-plan").find(".prd-contract-wrap.ui_active_toggle_wrap").removeClass("active");

                $('.contents.care-plan').find('.uiCarouselSlider1').vcCarousel({
                    responsive: [
                        {
                            breakpoint: 10000,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 3,
                                slidesToScroll: 3
                                
                            }
                        },
                        {
                            breakpoint: 1090,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 2, 
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: "unbuild"
                        }
                    ]
                });

                $('.contents.care-plan').find('.ui_carousel_slider3').vcCarousel({
                    settings: "unbuild",
                    responsive: [
                        {
                            breakpoint: 10000,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 2.35,
                                slidesToScroll: 1
                            }// BTOCSITE-73428 가전연계구독할인 - 보이는 갯수 변경
                        },
                        {
                            breakpoint: 1300,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 2, 
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1170,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 1.5, 
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                infinite: false,
                                variableWidth : false,
                                dots: false,
                                slidesToShow: 1, 
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: "unbuild"
                        }
                    ]
                });
                $('.contents.care-plan').find('.set_uiCarouselSlider .slide-wrap .slide-controls').show();                
                
                if($putItemContainer.is(':visible') == true) {
                    $putItemContainer.css('height', 'auto');
                    $putItemContainer.find('.contract-slide').removeAttr('style');
                    $putItemContainer.find('.total-info').removeAttr('style');
                    $putItemContainer.find('.total-info dl').show();
                    initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
                }
            }else if(breakpoint.name == 'mobile'){    
                $('.contents.care-plan').find('.set_uiCarouselSlider .slide-wrap').vcCarousel('destroy');    
                $('.contents.care-plan').find('.set_uiCarouselSlider .slide-wrap .slide-controls').hide();
                //$(".prd-select-wrap.ui_active_toggle_wrap").find(".ui_active_toggle").click();                
                //setMobilePutItemBoxStatus(true, true);
                
                
                //$putItemContainer.show();
                if($putItemContainer.is(':visible') == true) {
                    $putItemContainer.find('.contract-slide').css({transform: 'translateZ(0px)'})
                    $putItemContainer.find('.total-info').css({transform: 'translateZ(1px)'}) // BTOCSITE-73428 가전연계구독할인 - css 제어로 bg값 삭제 
                    $putItemContainer.find('.total-info dl').hide();
                    var wraptop = $putItemContainer.find('.total-info').outerHeight(true) + $putItemContainer.find('.tit-wrap').outerHeight(true) - 5;
                    $putItemContainer.css({height:wraptop});
                    var item = $putItemContainer.find('.ui_active_toggle')
                    item.css({transform:'rotate(180deg)'});
                    item.data('isOpen', false);
                    initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
                }

                $('.contents.care-plan').find('.uiCarouselSlider1 .slide-controls').hide() // BTOCSITE-73428 가전연계구독할인 - 구독중인 상품 영역 컨트롤 숨김
            }
        });        
        /* BTOCSITE-29875 [QA869] 렌탈/케어십 요금 확인 제품 카드 오류 end */
    }

    function eventBind(){        
        // 221125 수정 - 서브탭카테고리 클릭시 tab-fix 클래스 추가 속성 동일 적용
        // $categoryTab.on('click','.tabs li a', function(e){
        //     if( window.innerWidth < 768 || vcui.detect.isMobileDevice || vcui.detect.isApp ) {// 221109 추가 - 탭카테고리 결함 처리
        //         $fixedTab.css({'position':'fixed','left':'0px', 'right' :'0px', 'z-index' : '90', 'top' : '0px', 'margin-top' : '46px', 'padding' : '16px 0 4px','box-shadow' : '0 1px 10px 0 rgb(0 0 0 / 20%)'});
        //     }            
            
        // });
        

        $categoryTabCtrler.on('smoothscrolltabselecttab', function(e, data){
            var categorytop = $caresolutionContainer.offset().top;
            // if( window.innerWidth < 768 ) {// 221109 추가 - 탭카테고리 결함 처리
            //     categorytop = categorytop - 30;
            // }
            $('html').animate({scrollTop:categorytop}, 120, function(){ // BTOCSITE-40053
                loadCareProdList(true);
            });
        });

        $sortSelector.on('change', function(e){
            loadCareProdList(true, true);
        });

        $prodListContainer.on('click', '.putItemBtn', function(e){
            e.preventDefault();
            
            addPutItem(this);
        }).on('change', '.info-wrap select', function(e){
            e.preventDefault();

            changeItemOptions(this);
        });
        // 구독버튼 클릭시
        // BTOCSITE-22701 :: 2차 버튼 클릭시 PDP 로 이동하므로 팝업기능 주석처리
        /*
        $prodListContainer.on('click', '.btn-subscribe', function(e){
            
            var idx = $(this).parents('.prd-care-vertical').data('index') - 1;
            var throwData = _currentItemList[idx];
            $(this).trigger('pop', {'itemData': throwData});            
            
        });
        */

        $putItemContainer.on('click', 'button.btn-del', function(e){
            e.preventDefault();

            var itenIdx = $(this).closest('li').index();
            removePutItem(itenIdx);
        }).on('click', 'button.btn-close', function(e){
            e.preventDefault();

            putItemToggleStatus();
        }).on('click', '.total-info .btn', function(e){
            e.preventDefault();

            openEstimatePopUp();
        });

        $('.ui_active_toggle').on('click', function(e){
            e.preventDefault();

            var togglewrap = $(this).closest('.ui_active_toggle_wrap');

            togglewrap.toggleClass('active');
            
            if(togglewrap.hasClass('active')){
                lgkorUI.resetFlexibleBox();
            } ;
        });

        $putItemContainer.find('.ui_active_toggle').off('click').on('click', function(e){
            e.preventDefault();

            var isOpen = !$(this).data('isOpen');
            setMobilePutItemBoxStatus(isOpen, true);
            
            /* [구독][BTOCSITE-72586] [재구독 - 후속CSR] 요금확인 -가전구독 탭에서 2개를 담았을때 바텀시트 가려지는 현상 */
            var toggleWrap = $(this).closest('.ui_active_toggle_wrap');
            if(toggleWrap.hasClass('on')){
                toggleWrap.removeClass('on');
            }else{
                toggleWrap.addClass('on');
                setPutItemContainerHeight(toggleWrap); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 height 계산 수정
            }
            /* //[구독][BTOCSITE-72586] [재구독 - 후속CSR] 요금확인 -가전구독 탭에서 2개를 담았을때 바텀시트 가려지는 현상 */
        })

        //카드 할인 드롭다운 선택
        $('#pop-estimate').on('click','.alliance-card .select-list li a', function(e){
            e.preventDefault();
            
            var $this = $(this);
            var $dropDown = $this.parents('.ui_dropdown');
            var cardId = $this.data("cardId");
            var selectext = cardId == "" ? $('#pop-estimate').data("cardDescription") : $this.attr('data-card-title');
            $dropDown.find('a.ui_dropdown_toggle').text(selectext);
            
            $dropDown.vcDropdown("close");

            var maxCardSale = $this.attr('data-card-sale');
            if(maxCardSale > 0) {
                $('#pop-estimate').find('.discount-price').addClass('on');
                $('#pop-estimate').find('.discount-price').html("월 최대 <span>" + vcui.number.addComma(maxCardSale) + "</span>원 할인");
            } else {
                $('#pop-estimate').find('.discount-price').removeClass('on');
                $('#pop-estimate').find('.discount-price').html("");
            }

            $('#pop-estimate').data("selectId", $this.data('cardId'));

            var sumTotal = parseInt($('#pop-estimate').data("sumPrice"));
            var sum =  sumTotal - maxCardSale;
            if(sum < 0) sum = 0;
            var addCommaSum = vcui.number.addComma(sum);
            $('#pop-estimate').find(".estimate-usedPrice").html("월 <span>" + addCommaSum + "</span>원");

            $('#pop-estimate').find('.pop-conts > .bullet-list').hide();
            var descId = $this.data('descId');
            if(descId != "") $('#pop-estimate').find('.pop-conts > .bullet-list').eq(parseInt(descId)-1).show();            

        }).on('click', '.estimate-price > button', function(e){
            e.preventDefault();

            sendRequestConfirm();
        });

        $(window).on("scroll", function(){
            var scrolltop = $(window).scrollTop();
            var winheight = $(window).height();
            var contop = $caresolutionContainer.offset().top;
            var contheight = $caresolutionContainer.outerHeight(true);
            var bottomy = -scrolltop + contop + contheight;
            
            if(bottomy + 100 < winheight){
                setNextProdList();
            }
			
			setVisitCycleSelectBoxTitle(); // BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청 

            /* [구독][BTOCSITE-72586] [재구독 - 후속CSR] 요금확인 -가전구독 탭에서 2개를 담았을때 바텀시트 가려지는 현상 */
            if( window.innerWidth <= 767 ) {
                if($caresolutionContainer.find('.fixed-tab-wrap').hasClass('tab-fix')){
                    var headerH = $('.header').height();
                    setTimeout(function(){
                        $caresolutionContainer.find('.fixed-tab-wrap.tab-fix').css('margin-top', headerH);
                    },150)
                    $('.hello-bar-wrap .close').on('click', function(){
                        var headerH = $('.header').height();
                        setTimeout(function(){
                            $caresolutionContainer.find('.fixed-tab-wrap.tab-fix').css('margin-top', headerH);
                        },150)
                    })
                }else{
                    $caresolutionContainer.find('.fixed-tab-wrap').removeAttr('style');
                }
            }
            /* //[구독][BTOCSITE-72586] [재구독 - 후속CSR] 요금확인 -가전구독 탭에서 2개를 담았을때 바텀시트 가려지는 현상 */
		});
    }

    
    // S: BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
    function initBottomBtnArea(){
        var $defaultBottomWrap = $('div.default-bottom-wrap');
        var $bottomBtnArea = $putItemContainer.is('.close') || $putItemContainer.is(':hidden') ? $defaultBottomWrap : $putItemContainer;

        //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 open시 플로팅 버튼 위치 조정
        if ($putItemContainer.hasClass('on') && $putItemContainer.find('.total-info').length) {
            $bottomBtnArea = $putItemContainer.find('.total-info');
        }
        
        if ($bottomBtnArea.length > 0) {
            var floatingWrap = document.querySelector(".floating-wrap");
            var floatingChat = document.querySelector(".floating-chatbot");

            if (floatingWrap && floatingChat) {
                var bottom = parseInt($bottomBtnArea.css('bottom')) || 0;
                var areaH = $bottomBtnArea.outerHeight(true) + bottom;

                floatingWrap.style.setProperty('--bottom', areaH + 'px');
                floatingChat.style.setProperty('--bottom', areaH + 'px');
            }
        }
    }
    // E: BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정

	// BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청 START
    function setVisitCycleSelectBoxTitle() {
    	
    	// 방문주기 SelectBox Title setting.
    	// selectbox 생성 시 title 속성 부여 불가로 아래 로직 처리.
    	var tabName = $('.tabs').eq(1).find('li.on').children().text();
    	
    	void 0;
    	
    	if (tabName.indexOf('전기레인지') > -1) {
    		var $nowVisitCycle = $('select[data-sibling-type=siblingVisitCycle]').next().find('.ui-select-text');
    		
    		for (var i = 0; i < $nowVisitCycle.length; i++) {
    			if ($nowVisitCycle.eq(i).text() == "방문없음/상판무상교체(3년이후)") {
    				$nowVisitCycle.eq(i).attr("title", "방문없음/상판무상교체(3년이후)");
    			}
    		}
    	}
    }
    // BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청 END

    function setMobilePutItemBoxStatus(isOpen, anim){
        if(window.breakpoint.isMobile){
            var wraptop;
            var item = $putItemContainer.find('.ui_active_toggle');
            var statusBarHeight = vcui.detect.isMobileDevice && !isApp() && window.innerWidth < 768 ? 70 : 0; //BTOCSITE-1967 2차 수정
            //var statusBarHeight = 0; //BTOCSITE-1967
            if(isOpen){
                $putItemContainer.find('.contract-slide').removeAttr('style'); // BTOCSITE-5938-403 : BTOCSITE-5938-403 : 20211215 safari 버그 (transition, scroll 동시 사용할때 버그 있음)
                //$putItemContainer.find('.total-info').removeAttr('style'); // BTOCSITE-73428 가전연계구독할인 - css 제어로 변경
                $putItemContainer.find('.total-info dl').show();
                wraptop = $putItemContainer.find('.total-info').outerHeight(true) + $putItemContainer.find('.tit-wrap').outerHeight(true) + $putItemContainer.find('.slide-wrap').outerHeight(true) + $putItemContainer.find('.info-wrap').outerHeight(true) + 10; // BTOCSITE-73428 가전연계구독할인 - 신규 마크업 info-wrap 높이값 추가
                if(wraptop < 0) wraptop = 0;
                item.css({transform:'rotate(0deg)'});
                $putItemContainer.find('.total-info, .info-wrap').addClass("on"); // BTOCSITE-73428 가전연계구독할인 - class 제어점 추가
                setScrollToggle(true); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 open시 전체 스크롤 off
            } else{
                /* s BTOCSITE-5938-403 : 20211215 safari 버그 (transition, scroll 동시 사용할때 버그 있음) */
                $putItemContainer.find('.contract-slide').css({transform: 'translateZ(0px)'})
                //$putItemContainer.find('.total-info').css({background:'#ffffff', transform: 'translateZ(1px)'}) // BTOCSITE-73428 가전연계구독할인 - css 제어로 변경
                /* e BTOCSITE-5938-403 */
                $putItemContainer.find('.total-info dl').hide();
                wraptop = $putItemContainer.find('.total-info').outerHeight(true) + $putItemContainer.find('.tit-wrap').outerHeight(true) - 5;
                item.css({transform:'rotate(180deg)'});
                $putItemContainer.find('.total-info, .info-wrap').removeClass("on"); // BTOCSITE-73428 가전연계구독할인 - class 제어점 추가
                setScrollToggle(false); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 close시 전체 스크롤 on
            }
            item.data('isOpen', isOpen);
    
            if(window.breakpoint.name == 'mobile'){
                if(anim){
                    $putItemContainer.stop().animate({height:wraptop}, 220, function () {
                        if (!isOpen) initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
                    });//BTOCSITE-1967
                } 
                else {
                    $putItemContainer.css({height:wraptop});//BTOCSITE-1967
                    initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
                } 
            }
        }
    }

    function sendRequestConfirm(){
        lgkorUI.showLoading();

        var url = $('#pop-estimate').data('requestUrl');
        var sendata = {
            rtModelSeq: $('#pop-estimate').data('rtModelSeq'),
            easyRequestCard: $('#pop-estimate').data('selectId')
        }

        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(url, sendata, function(result){
            lgkorUI.hideLoading();
            
            var alert = result.data.alert;
            if(alert) {
                if(alert.isConfirm) {
                    //컨펌
                    var obj ={title: alert.title,
                        typeClass: '',
                        cancelBtnName: alert.cancelBtnName,
                        okBtnName: alert.okBtnName,
                        ok: alert.okUrl ? function (){
                            location.href = alert.okUrl;
                        } : function (){},
                        cancel: alert.cancelUrl ? function (){
                            location.href = alert.cancelUrl;
                        } : function (){}
                    };
    
                    var desc = alert.desc ? alert.desc : null;
                    if(alert.title && alert.desc) {
                        obj.typeClass = 'type2'
                    }
                    lgkorUI.confirm(desc, obj);
                } else {
                    //알림
                    var obj ={
                        title: alert.title,
                        typeClass: '',
                        cancelBtnName: alert.cancelBtnName,
                        okBtnName: alert.okBtnName,
                        ok: function (){}
                    };
    
                    var desc = alert.desc;
                    if(desc) {
                        obj.typeClass = 'type2'
                    }
                    lgkorUI.alert(desc, obj);
                }
            } else {
                window.location.href = result.data.sendUrl;
            }
        }, "POST");
    }
    // BTOCSITE-22701 :: 랜딩페이지 로드
    function loadLandingCategoryList(){
        lgkorUI.showLoading();
        var uitab = $fixedTab.find('.service_tab').vcTab('instance');
        uitab.select(_landingCategoryMap[location.hash].tab, true);
        _serviceID = _landingCategoryMap[location.hash].tab;

        var tabID = getTabID();
        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(_categoryListUrl, {tabID: tabID}, function(result){

            $categoryTab.find('.tabs').empty();

            var selectId = 0;
            var targetCategoryName = _landingCategoryMap[location.hash].categoryName;
            result.data.forEach(function(item, idx){
                if (item.categoryName == targetCategoryName){
                    selectId = idx;
                }
                var category = vcui.template(_categoryItemTemplate, item);
                $categoryTab.find('.tabs').append($(category).get(0));
            });
           
            $categoryTabCtrler.resetStatus(selectId);

            $('.service-tooltop .txt-wrap').hide();
            $('.service-tooltop .txt-wrap').eq(_serviceID).show();

            if(!_isStickyApply){
                _isStickyApply = true;
                $fixedTab.vcSticky({stickyContainer: ".care-solution-wrap", stickyClass:"tab-fix"});
            }
            
            loadCareProdList(false);
        });
    }

    //카테고리 로드...
    function loadCategoryList(){
        lgkorUI.showLoading();
                       
        if(!_isDirectCare && _careCateId){
            var uitab = $fixedTab.find('.service_tab').vcTab('instance');
            uitab.select(_careCateId.tabId, true);

            _serviceID = _careCateId.tabId;
        }

        var tabID = getTabID();
        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(_categoryListUrl, {tabID: tabID}, function(result){

            $categoryTab.find('.tabs').empty();

            var selectId = 0;
            for(var id in result.data){
                if(!_isDirectCare && _careCateId && _careCateId.tabCategoryId === result.data[id].categoryID){
                    selectId = id;
                }
                var category = vcui.template(_categoryItemTemplate, result.data[id]);
                $categoryTab.find('.tabs').append($(category).get(0));
            }
            $categoryTabCtrler.resetStatus(selectId);
            $categoryTab.find('.tabs li:first-child a').append('<em class="blind">선택됨</em>')

            $('.service-tooltop .txt-wrap').hide();
            $('.service-tooltop .txt-wrap').eq(_serviceID).show();

            if(!_isStickyApply){
                _isStickyApply = true;
                $fixedTab.vcSticky({stickyContainer: ".care-solution-wrap", stickyClass:"tab-fix"});
            }

            loadCareProdList(false);
        });
    }

    //상품 리스트 로드...
    function loadCareProdList(isLoading, isSelectChange){
        if(isLoading) lgkorUI.showLoading();
        
        // 구독카테고리일때 sort 기본값 최신순으로 변경하고 인기순,리뷰 많은순 숨김처리        
        if (!!isSelectChange == false){ // sort 변경으로 목록을 불러오는 경우가아닐때만 디폴트 sort값 변경            
            var bizType = getCategoryBizType();       
            if (bizType == 'SUBSCRIPTION'){
                if ($sortSelector.prop('selectedIndex') == 0 || $sortSelector.prop('selectedIndex') == 4){
                    $sortSelector.prop('selectedIndex', 1).vcSelectbox('update');
                }
                
                if (vcui.detect.isMobile){
                    $sortSelector.find('option').eq(0).hide();
                    $sortSelector.find('option').eq(4).hide();
                } else {
                    $sortSelector.siblings('.ui-selectbox-wrap').find('li').eq(0).hide();
                    $sortSelector.siblings('.ui-selectbox-wrap').find('li').eq(4).hide();
                }
            } else {
                if (vcui.detect.isMobile){
                    $sortSelector.find('option').eq(0).show();
                    $sortSelector.find('option').eq(4).show();
                } else {
                    $sortSelector.siblings('.ui-selectbox-wrap').find('li').eq(0).show();
                    $sortSelector.siblings('.ui-selectbox-wrap').find('li').eq(4).show();
                }
                $sortSelector.prop('selectedIndex', 0).vcSelectbox('update');
            }
        }
        
        var serviceName = getServiceName();
        var requestData = {
            tabID: getTabID(),
            categoryID: getCategoryID(),
            sortID: getSortID()
        }

        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(_prodListUrl, requestData, function(result){
            lgkorUI.hideLoading();
            
            if(!lgkorUI.stringToBool(result.data.success)){
                //console.log("테스트1")
                lgkorUI.commonAlertHandler(result.data.alert);
                return;
            }
            
            _currentItemList = vcui.array.map(result.data.productList, function(item, idx){                
                item['index'] = idx+1;
                item["serviceName"] = serviceName;

                setSiblingCodeNumbering(item);

                return item;
            });
            var leng = _currentItemList.length;
            var div = leng/_showItemLength;
            var rest = leng%_showItemLength;
            _page = 0;
            _pageTotal = parseInt(div);
            if(rest) _pageTotal += 1;

            $prodListContainer.find('> ul.inner').empty();

            if(leng){
                addProdItemList();
            } else{                
                var bizType = getCategoryBizType();       
                if (bizType == 'SUBSCRIPTION'){
                    $prodListContainer.find('> ul.inner').append(subNoData);
                } else {
                    $prodListContainer.find('> ul.inner').append(noData);
                }
            }

            if(!_isDirectCare && _careCateId && _careCateId.tabModelId) {
                var findArr = vcui.array.filter(result.data.productList, function(item, index) {
                    return (item.modelId == _careCateId.tabModelId);
                });
                if(findArr.length > 0) {
                    var findModel = JSON.parse(JSON.stringify(findArr[0]));
                    if(_careCateId.tabRtModelSeq) {
                        findModel.rtModelSeq = _careCateId.tabRtModelSeq;
                    }
                    requestAddPutItem(findModel);
                }
            }
            _isDirectCare = true;
            _careCateId = null;

            // 케어십탭에서 rentalCareType = "S" 일때 하단 담기영역 숨김처리
            if (getTabID() == 1){
                if (result.data.rentalCareType == 'S'){
                    $('.cont-wrap .default-bottom-wrap').hide();
                    $('.service-tooltop .txt-wrap').eq(1).hide();
                    $('.prd-select-wrap.ui_active_toggle_wrap').css({ 'display' : 'none'});
                } else {
                    $('.cont-wrap .default-bottom-wrap').show();
                    $('.service-tooltop .txt-wrap').eq(1).show();
                    if ($('.prd-select-wrap .contract-slide > .slide-wrap').length > 0){
                        $('.prd-select-wrap.ui_active_toggle_wrap').css({ 'display' : 'block'});
                        
                    }
                }
            }

            if (getTabID() == 0){
                $('.cont-wrap .default-bottom-wrap').show();
                $('.service-tooltop .txt-wrap').eq(1).hide();
                if ($('.prd-select-wrap .contract-slide > .slide-wrap').length > 0){
                    $('.prd-select-wrap.ui_active_toggle_wrap').css({ 'display' : 'block'});
                    //setPutItemStatus();
                }
            }
            
            // BTOCSITE-29324 START
            if (_isLanding && !!_landingCategoryMap[location.hash]){
            	var categorytop = $caresolutionContainer.offset().top;
                $('html, body').animate({scrollTop:categorytop}, 120, function(){
                	var basePosition = $categoryTab.width() + $categoryTab.offset().left;
                    
                    $('.cate-scroll-wrap.ui_smoothScroll_tab ul.tabs li a').each(function(index, element){
        				
        				//var tabName = $(this).text().replace('선택됨', '');
        				if (tabName == _landingCategoryMap[location.hash].categoryName) {
        					$(this).append("<em class='blind'>선택됨</em>")
        					var tagPosition = $(this).width() + $(this).offset().left;
        					if (basePosition < tagPosition) { // 카테고리명이 가려지는 경우 next icon 클릭하여 카테고리명을 정상노출 시킴.
        						$('.btn-arrow.next.ui_smooth_next').trigger('click');
        					}
        				}
        			})
                });
                _isLanding = false;
            }
			// BTOCSITE-29324 END
        });
    }

    function setSiblingCodeNumbering(item){
        var key;
        for(key in item.siblingFee) item.siblingFee[key].siblingCode = item.siblingFee[key].siblingCode.toString();
        for(key in item.siblingUsePeriod) item.siblingUsePeriod[key].siblingCode = item.siblingUsePeriod[key].siblingCode.toString();
        for(key in item.siblingVisitCycle) item.siblingVisitCycle[key].siblingCode = item.siblingVisitCycle[key].siblingCode.toString();   
        //BTOCSITE-9177   start 
        if(typeof item.siblingSvcType !== "undefined" && item.siblingSvcType.length > 0){
            
            for(key in item.siblingSvcType) item.siblingSvcType[key].siblingCode = item.siblingSvcType[key].siblingCode.toString();//BTOCSITE-9177  
        } 
        //BTOCSITE-9177   end
    }

    //서비스 변경...
    function changeService(sid){
        if(_serviceID != sid){
            _serviceID = sid;

            if(location.hostname === 'localhost'){
                if(_serviceID == 0){
                    _categoryListUrl = "/lg5-common/data-ajax/caresolution/carePlanerCategory.json";
                    _prodListUrl = "/lg5-common/data-ajax/caresolution/carePlanerProductList.json";
                } else{
                    _categoryListUrl = "/lg5-common/data-ajax/caresolution/carePlnerCareshipCategory.json";
                    _prodListUrl = "/lg5-common/data-ajax/caresolution/carePlanerCareshipList.json";
                }
            }

            loadCategoryList();
        }
    }

    //옵션 변경 시...
    function changeItemOptions(item){
        var idx = $(item).closest('.prd-care-vertical').data('index')-1;
        var optionData = getOptionData(item);

        var siblingType = $(item).data('siblingType');
        void 0
        if(siblingType == "siblingColors"){
            setChangeColorChip(idx, optionData.optdata);
        } else{
            setChangeOptionChip(idx, optionData.optdata, $(item).data('comboId'))
        }
    }

    //색상 외 옵션 변경...
    function setChangeOptionChip(idx, optdata, comboId){
        lgkorUI.showLoading();
        
        var sendata = {
            tabID: getTabID(),
            modelID: _currentItemList[idx]['modelId'],
            rtModelSeq: _currentItemList[idx]['rtModelSeq'],
            comboFlag: comboId,
            blockID: idx,
            categoryId: _currentItemList[idx]['categoryId'] // BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청 ADD
        }

        // BTOCSITE-3499 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발_후속작업
        // 파라메터 없을시 기본값 적용
        if(optdata['siblingContractPeriod']) sendata.contractPeriodCd = optdata['siblingContractPeriod'].value || 0;
        if(optdata['siblingUsePeriod']) sendata.usePeriodCd = optdata['siblingUsePeriod'].value || 0;
        if(optdata['siblingVisitCycle']) sendata.visitCycleCd = optdata['siblingVisitCycle'].value || 0;
        if(optdata['siblingFee']) sendata.feeCd = optdata['siblingFee'].value || 0;
		if(optdata['siblingSvcType']) sendata.svcTypeCd = optdata['siblingSvcType'].value; // BTOCSITE-9177

        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(_priceStatusUrl, sendata, function(result){
            lgkorUI.hideLoading();
            
            if(!lgkorUI.stringToBool(result.data.success)){
                //console.log("테스트2")
                lgkorUI.commonAlertHandler(result.data.alert);
                return;
            }
            
            var blockID = result.data.blockID;

            _currentItemList[blockID]["rtModelSeq"] = result.data["rtModelSeq"];
            _currentItemList[blockID]["monthlyPrice"] = result.data["monthPrice"];

            $prodListContainer.find('> ul.inner > li.item').eq(blockID).find('.price-wrap .price').html("월 <span>" + result.data["monthPrice"] + "</span>원");

            if(sendata.tabID == 0){
                var listBlock = $prodListContainer.find('> ul.inner > li.item').eq(blockID);

                // 20210720 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
                var o = result.data.siblingContractPeriod;
                var selectContractPeriodID = Object.keys(o).reduce(function (previous, current,currentIndex) {
                    return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                });
                selectContractPeriodID = o[selectContractPeriodID].siblingCode;


                var o = result.data.siblingUsePeriod;
                var selectUserPeriodID = Object.keys(o).reduce(function (previous, current,currentIndex) {
                    return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                });
                selectUserPeriodID = o[selectUserPeriodID].siblingCode;

                var o = result.data.siblingVisitCycle;
                var selectVisitCycleID = Object.keys(o).reduce(function (previous, current) {
                    return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                });
                selectVisitCycleID = o[selectVisitCycleID].siblingCode;

                var o = result.data.siblingFee;
                var selectFeeID = Object.keys(o).reduce(function (previous, current) {
                    return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                });
                selectFeeID = o[selectFeeID].siblingCode;

				// BTOCSITE-9177 START
                if(typeof result.data.siblingSvcType !== "undefined" && result.data.siblingSvcType.length > 0){
                    var o = result.data.siblingSvcType;
                    var selectSvcType = Object.keys(o).reduce(function (previous, current) {
                        return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                    });
                    selectSvcType = o[selectSvcType].siblingCode;
                }
                // BTOCSITE-9177 END
                setCliblingData(listBlock.find('select[data-sibling-type=siblingContractPeriod]'), result.data.siblingContractPeriod, result.data.selectContractPeriodID);
                setCliblingData(listBlock.find('select[data-sibling-type=siblingUsePeriod]'), result.data.siblingUsePeriod, result.data.selectUserPeriodID);
                setCliblingData(listBlock.find('select[data-sibling-type=siblingVisitCycle]'), result.data.siblingVisitCycle, result.data.selectVisitCycleID);
                setCliblingData(listBlock.find('select[data-sibling-type=siblingFee]'), result.data.siblingFee, result.data.selectFeeID);
				if(typeof result.data.siblingSvcType !== "undefined" && result.data.siblingSvcType.length > 0){
                    setCliblingData(listBlock.find('select[data-sibling-type=siblingSvcType]'), result.data.siblingSvcType, result.data.selectSvcTypeCd);// BTOCSITE-9177
                }
            }else{//BTOCSITE-31787 [IDX188] 요금확인페이지 세탁기 서비스유형 선택 오류-> 서비스 타입이 단건일때 START
            	
            	var listBlock = $prodListContainer.find('> ul.inner > li.item').eq(blockID);
            	
                if(typeof result.data.siblingSvcType !== "undefined" && result.data.siblingSvcType.length > 0){
                    var o = result.data.siblingSvcType;
                    var selectSvcType = Object.keys(o).reduce(function (previous, current) {
                        return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                    });
                    selectSvcType = o[selectSvcType].siblingCode;
                }
                
                if(typeof result.data.siblingSvcType !== "undefined" && result.data.siblingSvcType.length > 0){
                    setCliblingData(listBlock.find('select[data-sibling-type=siblingSvcType]'), result.data.siblingSvcType, result.data.selectSvcTypeCd);// BTOCSITE-9177
                }

            }
            //BTOCSITE-31787 [IDX188] 요금확인페이지 세탁기 서비스유형 선택 오류-> 서비스 타입이 단건일때 END
			setVisitCycleSelectBoxTitle(); // BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청
        });
    }
    function setCliblingData(selector, list, selectId){

        var selectIdx = 0;
        var list = vcui.array.map(list, function(item, idx){
            item['text'] =  item.siblingValue ;
            item['value'] = item.siblingCode;

            if(item.siblingCode == selectId) selectIdx = idx;
            return item;
        });
        selector.vcSelectbox('update', list).vcSelectbox('selectedIndex', selectIdx, false);

        // 20210720 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        if(list.length === 1) {
            selector.vcSelectbox('disabled',true);
            selector.closest('dl').addClass("disabled");
        } else {
            selector.vcSelectbox('disabled',false);
            selector.closest('dl').removeClass("disabled");
        }
    }

    //색상 옵션 변경...
    function setChangeColorChip(idx, optdata){
        lgkorUI.showLoading();
        
        var sendata = {
            tabID: getTabID(),
            modelID: optdata.siblingColors.modelId,
            colorCd: optdata.siblingColors.value,
            siblingGroupCd: optdata.siblingColors.groupId,
            rtModelSeq: _currentItemList[idx]['rtModelSeq'],
            blockID: idx
        }

        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(_changeColorUrl, sendata, function(result){
            lgkorUI.hideLoading();
            
            if(!lgkorUI.stringToBool(result.data.success)){
                //console.log("테스트3")
                lgkorUI.commonAlertHandler(result.data.alert);
                return;
            }

            var blockID = result.data.blockID;
            
            setSiblingCodeNumbering(result.data);
            for(var key in result.data){                
                _currentItemList[blockID][key] = result.data[key]; 
            }

            var deleteItem = $prodListContainer.find('> ul.inner > li.item').eq(blockID);

            if(!_currentItemList[blockID].modelUrlPath) _currentItemList[blockID].modelUrlPath = "";
            else{
               if(getTabID() == 0) _currentItemList[blockID].modelUrlPath += "?dpType=careTab";
            }

            var prodlist = vcui.template(_listItemTemplate, _currentItemList[blockID]);
            var addItem = $(prodlist).get(0);
            deleteItem.before(addItem);
            deleteItem.remove();

            $(addItem).find('.ui_selectbox').vcSelectbox().on('selectboxopen', function(e, sbox){
                var dl = $(sbox).closest('dl');
                if(!dl.hasClass('open')) dl.addClass('open');
            }).on('selectboxclose', function(e, sbox){
                var dl = $(sbox).closest('dl');
                if(dl.hasClass('open')) dl.removeClass('open');
            });

			setVisitCycleSelectBoxTitle(); // BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청
        });
    }

    //상품 리스트 더보기...
    function setNextProdList(){
        var page = _page + 1;
        if(page < _pageTotal){
            _page = page;

            addProdItemList(true);
        }
    }


    //더보기 리스트 추가...
    function addProdItemList(anim){
        var first = _page * 8;
        var last = first + _showItemLength;
        if(last > _currentItemList.length) last = _currentItemList.length;
        for(var i=first;i < last;i++){
            if(!_currentItemList[i].modelUrlPath) _currentItemList[i].modelUrlPath = "";
            else{
                if(getTabID() == 0) _currentItemList[i].modelUrlPath += "?dpType=careTab";
            }
            var prodlist = vcui.template(_listItemTemplate, _currentItemList[i]);
            var addItem = $(prodlist).get(0);
            $prodListContainer.find('> ul.inner').append(addItem);

            if(anim) $(addItem).css({y:200, opacity:0}).transition({y:0, opacity:1}, 450, "easeOutQuart");
        }

        $('.price-info dl:first-child').not('.default').addClass('default');

        $('.ui_selectbox').vcSelectbox().on('selectboxopen', function(e, sbox){
            var dl = $(sbox).closest('dl');
            if(!dl.hasClass('open')) dl.addClass('open');
        }).on('selectboxclose', function(e, sbox){
            var dl = $(sbox).closest('dl');
            if(dl.hasClass('open')) dl.removeClass('open');
        })
        
        setVisitCycleSelectBoxTitle(); // BTOCSITE-14020 전기레인지 신규 렌탈 요금제 출시에 따른 수정 요청
    }

    var tBtn = null; // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독

    //담기...
    function addPutItem(item){
        tBtn = $(item); // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
        var idx = $(item).parents('.prd-care-vertical').data('index')-1;
        var optionData = getOptionData(item);
        var itemList = _putItemList.concat();
        itemList.unshift({
            rtModelSeq: _currentItemList[idx]['rtModelSeq'],
            modelId: _currentItemList[idx]['modelId'],
            siblingCd: optionData.optdata.siblingColors ? optionData.optdata.siblingColors.value : "",
            siblingGroupCd: optionData.optdata.siblingColors ? optionData.optdata.siblingColors.groupId : ""
        });

		// BTOCSITE-64163. 태그문자 ajax 호출시 에러발생, br, sup 태그 치환
		var replaceItemList = JSON.stringify(itemList);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "<br>",   "&lt;br&gt;",   false);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "<sup>",  "&lt;sup&gt;",  false);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "</sup>", "&lt;/sup&gt;", false);

        var sendata = {
            type: "add",
            tabID: getTabID(),
            itemList: replaceItemList
        }
        
        requestPutItem(sendata);
    }

    function requestAddPutItem(data){
        var itemList = _putItemList.concat();
        itemList.unshift(data);

		// BTOCSITE-64163. 태그문자 ajax 호출시 에러발생, br, sup 태그 치환
		var replaceItemList = JSON.stringify(itemList);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "<br>",   "&lt;br&gt;",   false);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "<sup>",  "&lt;sup&gt;",  false);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "</sup>", "&lt;/sup&gt;", false);

        var sendata = {
            tabID: getTabID(),
            itemList: replaceItemList
        }
        
        requestPutItem(sendata);
    }

    //담기 삭제...
    function removePutItem(id){
        _putItemList.splice(id, 1);

		// BTOCSITE-64163. 태그문자 ajax 호출시 에러발생, br, sup 태그 치환
		var replaceItemList = JSON.stringify(_putItemList);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "<br>",   "&lt;br&gt;",   false);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "<sup>",  "&lt;sup&gt;",  false);
		replaceItemList = vcui.string.replaceAll(replaceItemList, "</sup>", "&lt;/sup&gt;", false);

        var sendata = {
            type: "remove",
            tabID: getTabID(),
            itemList: replaceItemList
        }
        
        requestPutItem(sendata);
    }

    function requestPutItem(sendata){
		// BTOCSITE-64163. 로딩바 제거
        lgkorUI.showLoading();

		// BTOCSITE-64163. timeout 추가
        lgkorUI.requestAjaxDataAddTimeout(_putItemUrl, 5000, sendata, function(result){
            
            if(!lgkorUI.stringToBool(result.data.success)){
                //console.log("테스트4")
                lgkorUI.commonAlertHandler(result.data.alert,tBtn); // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
                return;
            }

            if(result.data.isLogin){
                $('.freeCareshipBox').remove();
                var freeCareShip = result.data.contract.freeCareShip;
                if(freeCareShip == "Y" || freeCareShip == "X"){
                    $('.login-empty').hide();
                    
                    var template = freeCareShip == "Y" ? freeCareshipTemplate : addFreeCareShipTempalte;

                    $('.prd-contract-wrap.ui_active_toggle_wrap').show();
                    $('.ui_total_prod .ui_carousel_slider .slide-track').prepend(template);

                    
                    // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
                    $(".prd-select-wrap").attr("tabindex","0")
                    $(".prd-select-wrap").focus();
                }
                $('.ui_total_prod .ui_carousel_slider').vcCarousel('reinit');
                lgkorUI.resetFlexibleBox();
                
                if($('.ui_total_prod .ui_carousel_slider .slide-track').children().length == 1){
                    $('.prd-contract-wrap.ui_active_toggle_wrap').hide();
                    $('.login-empty').show();
                } 

                $('.ui_total_prod .ui_carousel_slider').find('.ui_flexible_box').removeClass('comb-type');
                if(result.data.contract.transModelCheck){
                    $('.ui_total_prod .ui_carousel_slider').find('.ui_flexible_box[data-contract-flag='+result.data.contract.transModelCheck+']').eq(0).addClass('comb-type');
                }
            }

            if(sendata.type == "add") {
                //console.log("테스트0")
                $('.toast-message').css('left','');// [BTOCSITE-73428] 가전연계구독할인

                // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
                var psw = $(".prd-select-wrap");
                psw.attr("tabindex","0")

                $('.toast-message').vcToast('instance').show('제품 담기가 완료되었습니다.','.prd-select-wrap'); // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독

                
            }

            // [BTOCSITE-73428] 가전연계구독할인
            var totalDcList = result.data.total.totalDcList;
            var dcListCnt = 0;
            if(totalDcList && totalDcList.length > 0) {
                totalDcList.forEach(function (dcInfo, i) {
                    if (dcInfo.type == 'price') {
                        dcListCnt++;
                    }
                });
            }
            if(dcListCnt > 0){
                $('#combineMaxDcInfo').show();
            }else{
                $('#combineMaxDcInfo').hide();
                closePutItemBox() // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
            }

            setPutItems(result.data);
        }, "GET", "json", true);
    }

    function setPutItems(listdata){
        $putItemContainer.find('.contract-slide').empty();

        _putItemList = [];
        
        var leng = listdata.itemList.length;
        if(leng){
            _putItemList = vcui.array.map(listdata.itemList, function(item){
                return {
                    rtModelSeq: item.rtModelSeq,
                    modelId: item.modelId,
                    siblingCd: item.siblingCd,
                    siblingGroupCd: item.siblingGroupCd
                }
            })

            var listItem = vcui.template(_putItemTemplate, {putitem_list: listdata.itemList});
            $putItemContainer.find('.contract-slide').append(listItem);

            var display = $putItemContainer.css('display');
            $putItemContainer.css({display:'block'});
            $('.contents.care-plan').find('.uiCarouselSlider1').vcCarousel({
                responsive: [
                    {
                        breakpoint: 10000,
                        settings: {
                            infinite: false,
                            variableWidth : false,
                            dots: false,
                            slidesToShow: 3,
                            slidesToScroll: 3
                            
                        }
                    },
                    {
                        breakpoint: 1090,
                        settings: {
                            infinite: false,
                            variableWidth : false,
                            dots: false,
                            slidesToShow: 2, 
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: "unbuild"
                    }
                ]
            });
            
            $('.contents.care-plan').find('.ui_carousel_slider3').vcCarousel({
                settings: "unbuild",
                responsive: [
                    {
                        breakpoint: 10000,
                        settings: {
                            infinite: false,
                            variableWidth : false,
                            dots: false,
                            slidesToShow: 2.35,
                            slidesToScroll: 1
                        } // BTOCSITE-73428 가전연계구독할인 - 보이는 갯수 변경
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            infinite: false,
                            variableWidth : false,
                            dots: false,
                            slidesToShow: 2, 
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1170,
                        settings: {
                            infinite: false,
                            variableWidth : false,
                            dots: false,
                            slidesToShow: 1.5, 
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            infinite: false,
                            variableWidth : false,
                            dots: false,
                            slidesToShow: 1, 
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: "unbuild"
                    }
                ]
            });
            if(leng < 3){
                $('.contents.care-plan').find('.ui_carousel_slider3').find('.slide-controls').hide();
            } else{
                $('.contents.care-plan').find('.ui_carousel_slider3').find('.slide-controls').show();
            }
            $putItemContainer.css({display:display});
        }

        var totalinfo = $putItemContainer.find('.total-info');
        var newinfo = vcui.template(putItemPriceTemplate, listdata.total);
        totalinfo.after(newinfo);

        totalinfo.remove();
        
        $putItemContainer.find('.tit-wrap .num strong').text(leng);

        setPutItemStatus();
    }

    function setPutItemStatus(){
        var leng = $putItemContainer.find('.contract-slide').children().length;
        if(leng){
            if($putItemContainer.css('display') == 'none'){
                var height = $putItemContainer.outerHeight(true);
                $putItemContainer.css({display:'block', y:height});
                openPutItemBox();
            } else{
                if($putItemContainer.hasClass('close')) openPutItemBox();
                else{
                    var isOpen = $putItemContainer.find('.ui_active_toggle').data('isOpen');
                    if(isOpen) { 
                        setMobilePutItemBoxStatus(true, true);
                        //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 및 삭제 시 height 다시 계산
                        if(window.breakpoint.isMobile){
                            setPutItemContainerHeight($putItemContainer)
                        }
                    }else{
                        if(window.breakpoint.isMobile){
                            //$putItemContainer.find('.total-info').css({background:'#ffffff'}) //BTOCSITE-73428 가전연계구독할인 - css 제어로 삭제
                            $putItemContainer.find('.total-info dl').hide();
                        }
                    }
                }
            }

            //$putItemContainer.attr("tabindex", -1).focus(); // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
            $("body").addClass('show-prdSelectWrap'); //BTOCSITE-40053
        } else{
            hidePutItemBox();
            $("body").removeClass('show-prdSelectWrap'); //BTOCSITE-40053
        }
    }

    function openPutItemBox(){
        putItemStatus("open");

        setMobilePutItemBoxStatus(false, false);

        $putItemContainer.stop().transition({y:0}, 550, "easeInOutCubic");
        //BTOCSITE-73428 가전연계구독할인 - padding값 css 처리
        //$putItemContainer.find('.tit-wrap').stop().transition({'padding-bottom':16}, 550, 'easeInOutCubic'); 
        $putItemContainer.find('.tit-wrap').stop().transition(550, 'easeInOutCubic'); 

        var height = $('.default-bottom-wrap').outerHeight(true);
        $('.default-bottom-wrap').stop().transition({y:height}, 450, "easeInOutCubic", function(){
            $('.default-bottom-wrap').hide();
        });
        $('div.contents.care-plan').find('.cont-wrap').addClass('selected-prd'); // BTOCSITE-5938-378
    }

    function closePutItemBox(){
        var tCont = $(".care-solution-wrap");
        tCont.attr("tabindex","0")

        tCont.focus();
    }

    function hidePutItemBox(){
        putItemStatus("close");

        var height = $putItemContainer.outerHeight(true);
        $putItemContainer.stop().transition({y:height}, 350, "easeInOutCubic", function(){
           $putItemContainer.css({display:'none', y:0});
           setPutItemContainerStyleInit(); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 담은 상품 모드 삭제 시 클래스 남는 현상 수정
           setScrollToggle(false); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 close시 전체 스크롤 on
           initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 close시 플로팅 버튼 위치 조정
        });

        height = $('.default-bottom-wrap').outerHeight(true);
        $('.default-bottom-wrap').stop().show().transition({y:0}, 450, "easeInOutCubic");
        $('div.contents.care-plan').find('.cont-wrap').removeClass('selected-prd'); // BTOCSITE-5938-378
    }

    function putItemToggleStatus(){
        if($putItemContainer.hasClass('close')){
            openPutItemBox();
        } else{
            closePutItemBox();
        }
    }
    function putItemStatus(status){
        if(status == "close"){
            if(!$putItemContainer.hasClass('close')) $putItemContainer.addClass('close');
            $putItemContainer.find('button.btn-close blind').text("열기");
        } else{
            if($putItemContainer.hasClass('close')) $putItemContainer.removeClass('close');
            $putItemContainer.find('button.btn-close blind').text("닫기");
        }
        initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
    }

    function openEstimatePopUp(){
        lgkorUI.showLoading();

        var sendata = {
            tabID: getTabID(),
            InputData: JSON.stringify(_putItemList)
        }

        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(_estimateConfirmUrl, sendata, function(result){
            lgkorUI.hideLoading();

            // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
            var psw = $(".prd-select-wrap");
            psw.attr("tabindex","0");
            
            if(!lgkorUI.stringToBool(result.data.success)){
                //console.log("테스트5")
                lgkorUI.commonAlertHandler(result.data.alert,psw); // BTOCSITE-77511 [웹앱 접근성 개선활동] 상품_구독
                return;
            }

            var estimatePrice = $('#pop-estimate').find('.estimate-price');
            var dcList = estimatePrice.find('.dcInfo');
            if(dcList && dcList.length > 0){
                for(var idx = dcList.length; idx > 0; idx--){
                    dcList.get(idx-1).remove();
                }
            }
            for(var str in result.data.priceInfo){
                if(str == 'totalDcList'){
                    var dcTemplate = '';
                    var totalDcList = result.data.priceInfo.totalDcList;
                    totalDcList.forEach(function(dcInfo,i){
                        if(dcInfo.type == 'notice'){
                            dcTemplate +=
                                '<dl class="re-subscribe dcInfo">' +
                                    '<dt>' + dcInfo.dcTitle + '</dt>' +
                                    '<dd>' + dcInfo.dcNotice + '</dd>' +
                                '</dl>'
                            ;
                        } else {
                            dcTemplate +=
                                '<dl class="dcInfo">' +
                                '<dt>' + dcInfo.dcTitle + '</dt>'+
                                '<dd>월 <span>-' + dcInfo.dcAmtTxt+ '</span>원</dd>'+
                                '</dl>'
                            ;
                        }
                    });
                    estimatePrice.find('#1monthOrgPrice').after(dcTemplate);
                }else{
                    estimatePrice.find('.estimate-' + str).html('월 <span>'+result.data.priceInfo[str]+'</span>원');
                }
            }

            $('#pop-estimate').data("requestUrl", result.data.priceInfo.requestUrl);
            $('#pop-estimate').data("sumPrice", result.data.priceInfo.sumPrice);

            $('#pop-estimate').find('.tooltip-wrap .tooltip-box a').attr('href', result.data.paymentInfo.discountUrl);

            var modelist = [];
            for(var idx in result.data.itemList) modelist.push(result.data.itemList[idx].csmsRtModelSeq);
            $('#pop-estimate').data("rtModelSeq", modelist.join(","));

         
            var $cardInfo = $('#pop-estimate').find('.alliance-card');
            var cardData = result.data.paymentInfo.card;
            if(cardData) {
                //카드데이타
                var selectList = $cardInfo.find('ul.select-list');
                selectList.empty();
                var groupItemTemplate = '<li class="divide"><span class="inner"><em>{{groupTitle}}</em></span></li>';

                /* BTOCSITE-8334 제휴카드 별 할인가 표기 */
                var cardItemTemplate = '<li>' +
                    '<a href="#" data-desc-id="{{descId}}" data-card-id="{{cardId}}" data-card-sale="{{salePrice}}" data-card-title="{{title}}">' +
                        '<span>{{label}}</span>' +
                        '<span class="card-discount">월 최대 <em class="price-line"><span>-{{vcui.number.addComma(salePrice)}}</span>원</em></span>' + //BTOCSITE-73428 가전연계구독할인 - 금액 태그 변경
                    '</a>' +
                '</li>';

                cardData.forEach(function(obj, idx) {
                    if(obj.groupTitle) {
                        selectList.append(vcui.template(groupItemTemplate,obj));
                    }
                    if(obj.listItem) {
                        obj.listItem.forEach(function(item, index) {
                            item.label = item.title;
                            //item.salePrice = vcui.number.addComma(item.salePrice); //salePrice에 콤마 추가 하니 총합 계산이 오류 템플릿에 콤마 기능 추가.

                            if(!item.cardId) {
                                item.label = "선택취소"
                                cardItemTemplate = '<li>' +
                                    '<a href="#" data-desc-id="{{descId}}" data-card-id="{{cardId}}" data-card-sale="{{salePrice}}" data-card-title="{{title}}">' +
                                        '<span>{{label}}</span>' +
                                    '</a>' +
                                '</li>';
                            } else {
                                cardItemTemplate = '<li>' +
                                    '<a href="#" data-desc-id="{{descId}}" data-card-id="{{cardId}}" data-card-sale="{{salePrice}}" data-card-title="{{title}}">' +
                                        '<span>{{label}}</span>' +
                                        '<span class="card-discount">월 최대 <em class="price-line"><span>-{{vcui.number.addComma(salePrice)}}</span>원</em></span>' + //BTOCSITE-73428 가전연계구독할인 - 금액 태그 변경
                                    '</a>' +
                                '</li>';
                            }
                            item.descId = idx;
                            selectList.append(vcui.template(cardItemTemplate, item));
                        });
                    }
                });
                /* //BTOCSITE-8334 제휴카드 별 할인가 표기 */
                
                $('#pop-estimate').data("cardDescription", result.data.paymentInfo.cardDescription);
                $cardInfo.find('.ui_dropdown a.ui_dropdown_toggle').text(result.data.paymentInfo.cardDescription);

                $cardInfo.show();
            } else {
                $cardInfo.hide();
            }
            $('#pop-estimate').find('.alliance-card .price').hide();
            //$list_ul.append($cardInfo);
            //$('#pop-estimate').find('.select-wrap').vcDropdown();
            
            $('#pop-estimate').find('.tit-wrap span.leng').empty().html("총 "+"<strong>"+result.data.totalCnt+"</strong>개");

            var listwrap = $('#pop-estimate').find('.estimate-list');
            var estimateProdList = vcui.template(_estimateProdTemplate, result.data);
            listwrap.after($(estimateProdList).get(0));
            listwrap.remove();

            $('#pop-estimate').find('.pop-conts > .bullet-list').hide();

            $('#pop-estimate').vcModal({opener:$putItemContainer.find('.total-info .btn')});
                
            $('#pop-estimate').find('.estimate-list').vcCarousel({
                settings: "unslick",
                responsive: [
                    {
                        breakpoint: 10000,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            infinite: false,
                            variableWidth : true,
                            dots: false,
                            slidesToShow: 1, 
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }

    function getTabID(){
        var uitab = $fixedTab.find('.service_tab').vcTab('instance');
        return uitab.getSelectIdx();
    }

    function getCategoryID(){
        var currentcate = $categoryTab.find('.tabs li[class=on]');
        var cateID = currentcate.find('a').data('cateId');
        
        return cateID;
    }

    function getCategoryBizType(){
        var currentcate = $categoryTab.find('.tabs li[class=on]');
        var bizType = currentcate.find('a').data('cateBiztype');
        
        return bizType;
    }
       
    function getSortID(){        
        return $sortSelector.val();
    }

    function getServiceName(){
        var currentab = $serviceTab.find('.tabs li[class=on]');
        
        return currentab.find('a').data("serviceName");
    }

    function getOptionData(item){
        var optgroup = $(item).closest('.prd-care-vertical').find('.info-wrap .opt-info')
        var optdata = {};
        var optstring = [];
        optgroup.children().each(function(idx, opt){
            var selectItem = $(opt).find('.ui_selectbox').vcSelectbox('instance');
            var selectValue = selectItem.value();
            var selectName = selectItem.text();
            var siblingType = selectItem.$el.data('siblingType');

            var optblock = $(opt).find('.ui_selectbox').find('option').filter("[value="+selectValue+"]");
            var selectModelId = optblock.data("modelId");
            var groupId = optblock.data("groupId");
            
            optdata[siblingType] = {
                name: selectName,
                value: selectValue,
                modelId: selectModelId,
                groupId: groupId
            }
        });

        if(_serviceID == 0){
            optstring.push(
                "가입비 " + optdata["siblingFee"].name + "원 선납",
                "계약기간 " + optdata["siblingUsePeriod"].name,
                "의무 사용기간 " + optdata["siblingUsePeriod"].name,
                "방문 주기 " + optdata["siblingVisitCycle"].name + "/1회"
            );
        }

        return {
            optdata: optdata,
            optstring: optstring
        };
    }

    //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 height 계산 수정
    function setPutItemContainerHeight(el) {
        var toggleWrap = el;
        var headerH = $('.header').outerHeight();
        var totalInfoH = $('.total-info').outerHeight();
        var statusBarH = $('.mobile-status-bar').outerHeight();
        var titH = $('.tit-wrap').outerHeight();
        var contractSlide = toggleWrap.find('.contract-slide');
        var infoWrapH = toggleWrap.find('.info-wrap').outerHeight() || 0;
        var toggleWrapH = headerH + statusBarH;
        var contractSlideOthH = headerH + totalInfoH + statusBarH + titH + infoWrapH;
        var toggleWrapH = 'calc(100dvh - ' + toggleWrapH + 'px)';
        var contractSlideH = 'calc(100dvh - ' + contractSlideOthH + 'px)';
        
        toggleWrap.css({
            "height": toggleWrapH,
            "max-height": toggleWrapH
        });
        contractSlide.css({
            "height": contractSlideH,
            "max-height": contractSlideH
        });
    }
    
    function setPutItemContainerStyleInit() {
        $putItemContainer.css('height', 'auto')
        $putItemContainer.find('.contract-slide').css('height', 'auto')
        $putItemContainer.removeClass('on');
    }

    function setScrollToggle(isOpen) {
        if (isOpen) {
            $('html, body').css({
                overflow:"hidden"
            });
            $('body').addClass('ignore-overflow-hidden');
            lgkorUI.setEnableAppScrollBottomMenu(false);
        } else {
            $('html, body').css({
                overflow:"visible"
            });              
            $('body').removeClass('ignore-overflow-hidden');
            lgkorUI.setEnableAppScrollBottomMenu(true);
        }
    }

    $(document).ready(function() {
        init();

        //BTOCSITE-1967
        $(window).on('resize', function(){
            //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 pc/mobile 전환 시 클래스 및 height 값 남는 현상 수정
            if( window.innerWidth >= 768 && $putItemContainer.is(':visible') == true) {
                setPutItemContainerStyleInit(); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 담은 상품 모드 삭제 시 클래스 남는 현상 수정
                setScrollToggle(false); //BTOCSITE-73428 가전연계구독할인 - 견적 확인할 제품 담기 영역 close시 전체 스크롤 on
            }
            initBottomBtnArea(); //BTOCSITE-73428 가전연계구독할인 - 플로팅 버튼 위치 조정
        });
    });
    
    $(window).load(function () {
        /* BTOCSITE-29875 [QA869] 렌탈/케어십 요금 확인 제품 카드 오류 start */       
        $('.contents.care-plan').find('.uiCarouselSlider1').vcCarousel('destroy');
        $(window).trigger('breakpointchange');
        /* BTOCSITE-29875 [QA869] 렌탈/케어십 요금 확인 제품 카드 오류 end */

    	$(".contents.care-plan").find(".prd-contract-wrap.ui_active_toggle_wrap").css("opacity", "1"); // BTOCSITE-27334 ADD (화면 로딩시 보유제품 카드 및 안내 카드가 겹쳐서 노출되어 추가)
    	
    	//BTOCSITE-22701 :: 랜딩페이지 처리
        if (_isLanding && !!_landingCategoryMap[location.hash]){
            loadLandingCategoryList();
        } else {
            loadCategoryList();
        }
    });
})();
